export default "__VITE_ASSET__CP_l4tBF__"